import axios from 'axios';
import { settings } from '@/plugins/settings';

export interface IMonthlyRegistrationsChannel {
  id: number;
  name: string;
  // one count per month, aligned with IMonthlyRegistrations.months
  counts: number[];
  total: number;
}

export interface IMonthlyRegistrations {
  // 'YYYY-MM', oldest first, the current month last
  months: string[];
  channels: IMonthlyRegistrationsChannel[];
}

export interface IRegistrationsSummaryChannel {
  name: string;
  count: number;
}

export interface IRegistrationsSummary {
  channels: IRegistrationsSummaryChannel[];
  total: number;
}

const base = settings.endpoint + 'reports/registrations';

export const reportsService = {
  monthlyRegistrations(): Promise<IMonthlyRegistrations> {
    return axios({ url: base + '/monthly', method: 'GET' }).then((response: any) => response.data.data);
  },

  registrationsSummary(startDate: string, endDate: string): Promise<IRegistrationsSummary> {
    return axios({ url: base + '/summary', method: 'GET', params: { start_date: startDate, end_date: endDate } })
      .then((response: any) => response.data.data);
  },
};
